// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"698":"1f8fe718","738":"a6245cef"}[chunkId] + ".chunk.css";
};